import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MAINTENANCE } from 'src/app/app-routing.module';
import { AuthenticationService } from '../services/authentication.service';
import { PUBLICLOGIN } from 'src/app/authentication-lead/authentication-lead.module';

export const retryCount = 0;
export const retryWaitMilliSeconds = 100;

@Injectable({
  providedIn: 'root',
})
export class GeneralInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry({ count: retryCount, delay: retryWaitMilliSeconds }),
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 0 && error.url.includes(environment.apiUrl)) {
            this.router.navigate([MAINTENANCE]);
            return throwError(() => new Error('FP: Unable to Connect to the Server:' + error.message));
          } else if ([401, 403].includes(error.status)) {
            // Do not force logout on authentication endpoints.
            // Those errors should be handled by the login UI (e.g. deeplink email mismatch).
            const isAuthEndpoint =
              request.url.startsWith(environment.apiUrl + '/auth/jwt/create/') ||
              request.url.startsWith(environment.apiUrl + '/auth/users/');
            if (!isAuthEndpoint) {
              this.authService.signOut();
              this.router.navigate([PUBLICLOGIN]);
            }
            return throwError(() => error);
          } else {
            return throwError(() => error);
          }
        }
        return throwError(() => error);
      })
    );
  }
}
